<template>
  <div class="bread">
    <div class="example-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div class="backimg"></div>
        <el-breadcrumb-item
          v-for="(item,index) in breadList"
          :key="index"
          :to="{ path: item.path }"
        >
          {{item.meta.title}}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      breadList: [] // 路由集合
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  methods: {
    isHome () {
      return this.$route.path === '/'
    },
    getBreadcrumb () {
      let matched = this.$route.matched
      //   if(matched[0].path == '/Projecthistory'){
      //     matched = [{ path: "/Projectprogressview", meta: { title: "项目进度查看" } }].concat(matched);
      //   } else if(matched[0].path == '/Informationhistory'){
      //     matched = [{ path: "/Auditandmanagement", meta: { title: "审核与查看" } },{ path: "/Auditandmanagement/Basicinformation", meta: { title: "基本信息修改记录" } }].concat(matched);
      //   }
      if (!this.isHome(matched[0])) {
        // matched = [{ path: "/", meta: { title: "总览" } }].concat(matched);
      } else {
        matched = [{ path: '/', meta: { title: '首页' } }]
      }
      this.breadList = matched
    }
  },
  created () {
    this.getBreadcrumb()
  }
}
</script>
<style  lang="scss">
.bread .el-breadcrumb {
  display: block;
  font-size: 15px;
  display: flex;
  align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #C0C4CC;
    padding-bottom: 15px;
}
.bread .is-link {
  font-weight: normal;
}
.bread .example-container .backimg {
  height: 20px;
  width: 20px;
  margin-left: 10px;
  margin-right: 10px;
  background-image: url("../assets/ding.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}
</style>
